import React from 'react';
//Función principal
const InterveningInfo = props => {
    //Tomo los props
    const { intervening, index } = props;
    //Renderizo
    return (
        <div className="card mb-2 border-secondary">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 className="m-0 font-weight-bold text-dark">INTERVINIENTE #{ index + 1 }</h6>
            </div>
            <div className="card-body">
                <div className="h6 mb-0 font-weight-bold text-gray-800">
                    <div className="row">
                        <div className="col-md-4 mb-1">
                            <small>APELLIDO Y NOMBRE:</small>
                            <br/>
                            { intervening.persona ? intervening.persona.apellido + ', ' + intervening.persona.nombre : ''}
                        </div>
                        <div className="col-md-2 mb-1">
                            <small>CARÁCTER:</small>
                            <br/>
                            { intervening.caracter ? intervening.caracter.descripcion : '' }
                        </div>
                        <div className="col-md-2 mb-1">
                            <small>TELÉFONO:</small>
                            <br/>
                            { intervening.telefono }
                        </div>
                        <div className="col-md-4 mb-1">
                            <small>DOMICILIO:</small>
                            <br/>
                            { intervening.domicilio }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InterveningInfo;